import React from 'react'
import { HashLink as Link } from 'react-router-hash-link'
import "./Header.css"
function Header(props) {
    return (
        <>

      <nav>
     
      
      
      <ul>
        <li><Link className="navlink" to="/#home">Home</Link></li>
        <li><Link className="navlink" to="/#about">About Me</Link></li>
        <li><Link className="navlink" to="/#work">Work</Link></li>
        <li><Link className="navlink" to="/#contact-page">Contact</Link></li>
      </ul>
      </nav>

      
      
        </>
    )
}

export default Header
